import { useState, useEffect, ReactNode } from 'react'
import type React from 'react'

import {
    Button,
    Header,
    HeaderNavigationItem,
    Navigation,
} from '@bosch/react-frok'

import Link from '@/ui/components/Header/Link'
import { useSpace } from '@/hooks/useSpace'
import type { CustomHeaderProps } from './types/CustomHeaderTypes'

import './CustomHeader.scss'

const CustomHeader = ({
    className,
    currentAssistantName,
    quickLinks,
    showMenu,
    showQuickLinks
}: CustomHeaderProps) => {
    const [assistantMenu, setAssistantMenu] = useState<ReactNode>(undefined)
    const { spaces } = useSpace()

    const getMenu = (): { menu: ReactNode; menuTrigger: string | null } => {
        let menu: ReactNode = null
        let menuTrigger: string | null = null

        const defaultMenuTrigger = 'Menu'

        const defaultMenu = (
            <Navigation>
                <Link href="/#" label="Further Examples" />
            </Navigation>
        )

        if (showMenu != false) {
            menu = assistantMenu || defaultMenu
            menuTrigger = defaultMenuTrigger
        }

        return { menu, menuTrigger }
    }

    useEffect(() => {
        const assistantsList = spaces.flatMap((space) => space.assistants)

        if (assistantsList && showMenu && showQuickLinks) {
            const links: React.ReactElement[] = []
            let menu: ReactNode = null

            assistantsList?.map((assistant) => {
                const config = assistant.config

                links.push(
                    <Link
                        key={config.id}
                        href={assistant.path}
                        label={config.name}
                    />
                )
            })

            menu = (
                <div className="navigation-wrapper">
                    <Navigation>
                        <Link href={'/'} label="Home" />
                        <HeaderNavigationItem
                            key="assistants-head"
                            trigger={
                                <Button
                                    key="assistants-head-button"
                                    label="Assistants"
                                    onClick={() => { }}
                                />
                            }
                        >
                            {links}
                        </HeaderNavigationItem>
                    </Navigation>
                </div>
            )

            setAssistantMenu(menu)
        }
        // The menu is built once, when the header is mounted
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Header
            className={className}
            logo={{ href: '/' }}
            menu={getMenu().menu}
            menuTrigger={getMenu().menuTrigger}
            quickLinks={showQuickLinks && quickLinks && quickLinks.length > 0 ? quickLinks : []}
        >
            {currentAssistantName && <div>{currentAssistantName}</div>}
        </Header>
    )
}

export default CustomHeader
